/* eslint-disable @typescript-eslint/no-explicit-any */

import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { Persistor } from 'redux-persist';
import { createStore } from './store/create-store';
import { middleware, persistConfig, rootReducers } from './store/store-registry';

const feature = {
  enablePersistence: true,
  persistConfig: persistConfig,
};

// create store
const storeGenerate = createStore(rootReducers, middleware, feature);

// create persistor
export const store = storeGenerate.store;
export const persistor: Persistor | any = storeGenerate.persistor;

// type definitions
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

// dispatch & selector
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
